.icon {
    font-size: 20px;
}

.message {
    font-family: monospace;
    font-size: var(--font-small);
    white-space: pre-wrap;
    word-break: break-word;
    margin: 0;
}

.stackTrace {
    background-color: var(--grey-dk);
    color: var(--off-white);
    padding: 12px;
    border-radius: 3px;
    font-family: monospace;
    font-size: 12px;
    white-space: pre-wrap;
    word-break: break-word;
    max-height: 300px;
    overflow: auto;
    margin: 0;
}
